import React, { useContext } from 'react';
import fieldParams from '../../const/fieldParams';
import normalizePhone from '../../utils/normalizePhone';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import { ReactComponent as ChatIcon } from '../../assets/img/chat.svg';
import { ReactComponent as PhoneIcon } from '../../assets/img/call.svg';
import '../../assets/styles/contact-driver.sass';

const ContactDriver = () => {
  const { updateEditor } = useContext(BookerContext);
  const { togglePopup } = useContext(BookerShortContext);
  const key = 'call';
  const driverPhoneNumber = '7039912227';

  const sendNotesField = () => {
    updateEditor({ key: 'notes' });
  };

  const openCallPopup = () => {
    if (!driverPhoneNumber) return;
    fieldParams[key].popupText = normalizePhone(driverPhoneNumber);
    const callBtn = [
      {
        isSecondary: true,
        textBtn: 'Cancel',
      },
      {
        clickHandler: callDriver,
        textBtn: 'Call',
      },
    ];
    togglePopup(true, key, callBtn);
  };

  const callDriver = () => {
    togglePopup(false, key);
    document.location.href = `tel:${driverPhoneNumber}`;
  };

  return (
    <div className="contact-btns">
      <div className="chat-btn" onClick={sendNotesField}>
        <ChatIcon />
      </div>
      <div
        className={`phone-btn${driverPhoneNumber ? '' : ' disabled'}`}
        {...(driverPhoneNumber && { onClick: openCallPopup })}
      >
        <PhoneIcon />
      </div>
    </div>
  );
};

export default ContactDriver;
